<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="750px">
      <v-skeleton-loader
        v-if="loading"
        type="article, actions"
      ></v-skeleton-loader>
      <v-card v-if="!loading">
        <v-card-title style="padding: 10px 0 0 10px; height: 20px;">
          <v-col cols="12">
            <span style="font-size: 20px;">
              {{
                !data.id
                  ? $t("wkt.admin.partners.partner_window.new_partner")
                  : $t("wkt.admin.partners.partner_window.edit_partner")
              }}
            </span>
          </v-col>
        </v-card-title>
        <v-card-text style="padding-bottom: 0;">
          <v-container @wheel="onWheel">
            <v-form ref="form">
              <v-row style="margin-top: 20px;">
                <v-col cols="12">
                  <v-text-field
                    v-model="creationDate"
                    :label="$t('wkt.admin.partners.partner_window.edit_created')"
                    autocomplete="none"
                    :rules="[validationRules.required]"
                    max="200"
                    disabled
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="data.type"
                    :label="$t('wkt.admin.partners.partner_window.partner_type')"
                    autocomplete="none"
                    max="400"
                    :items="partnersTypes"
                    item-text="name"
                    item-value="id"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="data.companyId"
                    :items="companiesNotAssignedToPartner"
                    item-text="name"
                    item-value="id"
                    :label="$t('wkt.admin.partners.partner_window.edit_client')"
                    :rules="[validationRules.required]"
                    max="200"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="data.parentPartnerId"
                    :items="partnersList"
                    item-text="companyName"
                    item-value="id"
                    :label="$t('wkt.admin.partners.partner_window.edit_depends')"
                    max="200"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.email"
                    :label="$t('wkt.admin.partners.partner_window.email')"
                    :rules="[validationRules.required, validationRules.email]"
                    max="200"
                  />
                </v-col>

                <v-col cols="6" class="pb-0">
                  <v-switch
                    v-model="data.enabled"
                    :label="$t('wkt.admin.partners.partner_window.edit_enabled')"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
            <v-icon left color="#ffffff">delete</v-icon>
            <span style="color: #ffffff;">{{
              $t("wkt.admin.common.dialog-buttons.delete").toUpperCase()
            }}</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#185EA9"
            text
            @click="onSave()"
            style="font-size: 0.9em; font-weight: 400;"
            >{{ $t("wkt.admin.common.dialog-buttons.ok").toUpperCase() }}
          </v-btn>
          <v-btn
            text
            @click="showDialog = false"
            style="font-size: 0.9em; font-weight: 400;"
            >{{
              $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase()
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog
      ref="dlgConfirm"
      :title="$t('wkt.admin.partners.partner_remove.confirm_dialog.title')"
      :message="$t('wkt.admin.partners.partner_remove.confirm_dialog.subtitle')"
      v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
      v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
      v-on:confirmed="deleteItem()"
    />
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import ConfirmDialog from "../../common/ConfirmDialog";
import api from "../../../api/worktime";
//import gwt from '../../../api/gwt'
import CommonFormatter from "../../common/CommonFormatter.js";

export default {
  name: "PartnersDialog",
  mixins: [BaseModule, CommonFormatter],
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      showDialog: false,
      creationDate: null,
      loading: true,
      data: {},
      partnersTypes: [
        { id: 0, name: this.$t('wkt.admin.partners.partner_window.partner_type.standard') },
        { id: 1, name: this.$t('wkt.admin.partners.partner_window.partner_type.integration') },
        { id: 2, name: this.$t('wkt.admin.partners.partner_window.partner_type.company_group') },
      ],
      companyList: [],
      partnersList: [],
      companiesNotAssignedToPartner: [],
    };
  },
  methods: {
    onWheel(ev) {
      ev.stopPropagation();
    },
    // eslint-disable-next-line no-unused-vars
    open(action, payload) {
      this.showDialog = true;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      if (!payload) {
        this.data = {
          creationDate: new Date().getTime(),
          type: 0,
          companyId: null,
          currentSeats: 0,
          id: null,
          parentPartnerId: null,
          enabled: true
        };
        this.creationDate = this.formatDateTime(new Date());
        this.getPartners();
        this.loading = false;
        return;
      }

      this.loading = true;
      api.getPartnerById(
        payload,
        (res) => {
          this.loading = false;
          this.creationDate =
            this.data && this.data.creationDate
              ? this.formatDateTime(this.data.creationDate)
              : this.formatDateTime(new Date());
          this.data = res;
          this.getPartners();
        },
        (error) => {
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
          this.loading = false;
        }
      );
    },
    getPartners() {
      this.loading = true;
      api.getPartners(
        (res) => {
          this.loading = false;
          this.partnersList = res;
          this.getCompanies();
          this.filterPartners();
        },
        (error) => {
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
          this.loading = false;
        }
      );
    },
    getCompanies() {
      api.getCompanies(
        (res) => {
          this.companyList = res;
          this.filterCompanies();
        },
        (error) => {
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
          this.loading = false;
        }
      );
    },
    filterPartners() {
      console.log(`Partners: ${JSON.stringify(this.partnersList)}`)
        this.partnersList.unshift({
          id: null,
          companyName: this.$t('wkt.admin.common.without_parent_partner'),
        });
    },
    filterCompanies() {
      const partnerCompanyIds = this.partnersList
        .map((x) => x.companyId)
        .filter((x) => x !== this.data.companyId);
      this.companiesNotAssignedToPartner = this.companyList.filter(
        (x) => !partnerCompanyIds.includes(x.id)
      );
      if (!this.data.id) {
        this.companiesNotAssignedToPartner.unshift({
          id: null,
          name: this.$t('wkt.admin.common.select_customer'),
        });
      }
    },
    confirmDelete() {
      this.$refs.dlgConfirm.confirm(this.data);
    },
    onSave() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      api.storePartner(this.data,
        () => {
          this.data = {
            companyId: this.companyId,
            creationDate: new Date().getTime(),
            currentSeats: 0,
            type: this.type,
            parentPartnerId: this.parentPartnerId,
          };
          this.loading = false;
          this.$emit("refresh");
          this.showDialog = false;
        },
        (error) => {
          this.$log.error(error);
          this.loading = false;
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
        }
      );
    },
    deleteItem() {
      api.otherPartnersDependOnPartner(
        this.data.id,
        (res) => {
          this.loading = false;
          if (res > 0) {
            this.showDialog = false;
            let message = this.$t('wkt.admin.partners.partner_remove.btn-delete-error');
            message = message.replace('%d', `${res}`)
            this.$emit("show-alert", { text: message, color: "error", timeout: 3000 });
          } else {
            api.deletePartner(
              this.data.id,
              () => {
                this.loading = false;
                this.$emit("refresh");
                this.showDialog = false;
              },
              (error) => {
                this.loading = false;
                this.showDialog = false;
                this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
              }
            );
          }
        },
        (error) => {
          this.loading = false;
          this.showDialog = false;
          this.$emit("show-alert", { text: error, color: "error", timeout: 3000 });
        }
      );
    },
  },
};
</script>
